import { useTranslations } from 'next-intl'

import classNames from 'classnames'

import {
  TrackingLozenge,
  TrackingLozengeState,
} from '~/components/atoms/TrackingLozenge'

import type { ImageProps } from '../../atoms/Image/Image'
import { useArtworkCardButtons } from '../ArtworkCardButtons/useArtworkCardButtons'

import styles from './ArtworkCardPortfolio.module.css'

interface ArtworkCardPortfolioProps {
  artworkId: string
  artworkImage: ImageProps
  artistId: string
  className?: string
  artistName?: string
  artworkName?: string
  eventLocation: string
  artworkDetails: any
}

export default function ArtworkCardPortfolio({
  artworkId,
  artworkImage,
  artistId,
  className,
  artistName,
  artworkName,
  eventLocation,
  artworkDetails,
}: ArtworkCardPortfolioProps) {
  const t = useTranslations('common')
  const {
    isPortfolioTicket,
    isWatchingTicket,
    // isSellingTicket,
    isAddingPortfolio,
    isAddingWatching,
    isRemovingWatchlist,
    handleContainerClick,
    handleBookmarkClick,
  } = useArtworkCardButtons(
    artworkId,
    artworkImage,
    artistId,
    eventLocation,
    artistName,
    artworkName,
    artworkDetails
  )

  // if (isSellingTicket) return null

  const state = isPortfolioTicket
    ? TrackingLozengeState.Collection
    : isWatchingTicket
      ? TrackingLozengeState.Watchlist
      : TrackingLozengeState.Default
  const isTracked = state !== TrackingLozengeState.Default
  const label = isTracked ? t('manageTracking') : t('trackThisArtwork')

  return (
    <div
      className={classNames(styles.container, className)}
      onClick={handleContainerClick}
      data-artwork-id={artworkId}
    >
      <TrackingLozenge
        state={state}
        onClick={handleBookmarkClick}
        disabled={isAddingPortfolio || isAddingWatching || isRemovingWatchlist}
        id={`portfolio-${artworkId}`}
        testID={`portfolio-${artworkId}`}
        title={label}
        aria-label={label}
      />
    </div>
  )
}
